import { createFileRoute } from "@tanstack/react-router";
import { buildPageHead } from "@/lib/seo";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/blog/")({
  head: () =>
    buildPageHead({
      title: "Blog: SaaS Growth Playbooks & Metric Guides | Bigdelta",
      description:
        "Best practices, workflows and metric guides across signups, activation, conversion, expansion, contraction, churn and reactivation.",
      path: "/blog",
    }),
  component: Blog,
});
